import React from "react";
import { Box, Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import { PAGE_TEXT } from "./paymentPage.constants";

function isOrderSummaryShown(pageView, orderSummary) {
    if (pageView.isSummaryVisible === false) {
        return false;
    }
    return orderSummary.isAvailable;
}

function OrderSummaryLine({ label, value, spacing }) {
    return (
        <Box sx={spacing}>
            <Typography variant="body2" color="text.secondary">
                {label}
            </Typography>
            <Typography variant="body1" sx={{ mt: 0.5 }}>
                {value}
            </Typography>
        </Box>
    );
}

function PaymentPageOrderSummary({ pageView, orderSummary }) {
    if (isOrderSummaryShown(pageView, orderSummary) === false) {
        return <></>;
    }
    return (
        <Grid size={{ xs: 12, md: 4 }}>
            <Card variant="outlined">
                <CardContent>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        {PAGE_TEXT.ORDER_SUMMARY}
                    </Typography>
                    <Divider />
                    <OrderSummaryLine label={PAGE_TEXT.VENDOR} value={orderSummary.vendor} spacing={{ my: 2 }} />
                    <OrderSummaryLine
                        label={PAGE_TEXT.DESCRIPTION}
                        value={orderSummary.description}
                        spacing={{ mb: 2 }}
                    />
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            {PAGE_TEXT.AMOUNT}
                        </Typography>
                        <Typography variant="h5" sx={{ mt: 0.5, fontWeight: "bold" }}>
                            {orderSummary.amount}
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="caption" color="text.secondary">
                            {orderSummary.reference}
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
}

export default PaymentPageOrderSummary;
